import { render, staticRenderFns } from "./FixedPay.vue?vue&type=template&id=8752a566&scoped=true"
import script from "./FixedPay.vue?vue&type=script&lang=js"
export * from "./FixedPay.vue?vue&type=script&lang=js"
import style0 from "./FixedPay.vue?vue&type=style&index=0&id=8752a566&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8752a566",
  null
  
)

export default component.exports